import { ConversationsService } from '@/service/ConversationsService'
import Model from './Model'
import { IUser } from './Users'

export interface IConversation {
  _id: string
  name: string
  members: Array<string>
  type: string
  locationId: string
  messages: Array<any>
  lastReadAt: Date
  lastMessageAt: string
  createdAt: string
  recepients: Array<IUser>
  blockedBy: Array<string>
  minimized: boolean
}
export interface IConversationMessage {
  sender: string
  content: string
}
export interface IConversationMessageContent {
  text?: string
  media?: { type: MediaContentType; url: string; name: string }
}
export enum MediaContentType {
  IMAGE = 'image',
  GIF = 'gif',
  VIDEO = 'video',
  AUDIO = 'audio',
  FILE = 'file',
}
export enum ConversationType {
  DM = 'DM',
  GROUP = 'GROUP',
}

export interface IConversationSuggestion {
  _id: string
  contactId: string
  token: string
  fullName: string
  avatar: string
  locationId: string
  slug: string
}

export default class Conversations extends Model {
  constructor(payload: IConversation) {
    super(payload, ConversationsService)
  }

  get locationId(): string {
    return this._data.locationId
  }

  set locationId(locationId: string) {
    this._data.locationId = locationId
  }

  get createdAt(): string {
    return this._data.createdAt
  }

  set createdAt(createdAt: string) {
    this._data.createdAt = createdAt
  }

  get messages(): Array<any> {
    return this._data.messages
  }

  set messages(messages: Array<any>) {
    this._data.messages = messages
  }
}
